import { atom } from "jotai";
import type { UUID } from "../../../utils/uuid";

/**
 * When a user submits a prompt (MFAI or moment flow), a single
 * `content_generation` row is created and its ID is stored here.
 * The layout configuration / tone text atoms then use this ID to link
 * their `content_generation_result` rows to the single parent instead of
 * each creating a separate `content_generation` row.
 */
export const contentGenerationIdAtom = atom<UUID | null>(null);
